import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { greyBorderStyle, cardStyle, contentBoxStyle } from "../shared/Theme";
import Sidebar from "../elements/Sidebar";
import Header from "../elements/Header";
import companyEmployeeService from "../services/companyEmployeeService";
import RiskOverTimeGraph from "../elements/CyberTraining/RiskOverTimeGraph";
import AverageTrainingScore from "../elements/CyberTraining/AverageTrainingScore";
import { FiberManualRecord } from "@mui/icons-material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { truncateString } from "../shared/sharedFunctions";
import GroupsModal from "../elements/CyberTraining/GroupsModal";
import CompanyEmployeesModal from "../elements/CyberTraining/CompanyEmployeesModal";
import CoursesModal from "../elements/CyberTraining/CoursesModal";
import Speedo from "../elements/Dashboard/Speedo";
import IndividualEmployeeModal from "../elements/CyberTraining/IndividualEmployeeModal";
import CyberTrainingCreateCourseModal from "../elements/CyberTraining/CyberTrainingCreateCourseModal";
import IndividualGroupModal from "../elements/CyberTraining/IndividualGroupModal";
import IndividualCourseModal from "../elements/CyberTraining/IndividualCourseModal";
import AccountGuard from "../elements/Admin/AccountGuard";
import policyService from "../services/policyService";
import { amber, red } from "../shared/colours";
import companyService from "../services/companyService";

const CyberTraining = () => {

	let [ companyEmployees ] = useState(companyEmployeeService.companyEmployees);
	let [ courseStats, setCourseStats ] = useState(companyEmployeeService.courseStats);
	let [ groups, setGroups ] = useState(companyEmployeeService.groups);
	let [ showGroup, setShowGroup ] = useState(null);
	let [ showEmployees, setShowEmployees ] = useState(null);
	let [ showCourses, setShowCourses ] = useState(null);
	let [ showCreateCourse, setShowCreateCourse ] = useState(false);
	let [ showIndividualEmployeeModal, setShowIndividualEmployeeModal ] = useState(false);
	let [ showIndividualGroupModal, setShowIndividualGroupModal ] = useState(false);
	let [ showIndividualCourseModal, setShowIndividualCourseModal ] = useState(false);
	
	useEffect(() => {
		companyEmployeeService.onCourseStats(() => {
			setCourseStats(companyEmployeeService.courseStats);
			setGroups(companyEmployeeService.groups);
		});
	}, []);
	
	const handleHubClick = () => {
		window.open(`https://app.user-training.com`);
	};
	
	const handleMagicClick = () => {
		window.open(`https://app.user-training.com/portal/${companyService.selectedCompany.usecure_id}`);
	};
	
	const handleGroupClick = (group) => {
		setShowGroup(group);
	};
	
	const handleGroupModalClose = () => {
		setShowGroup(null);
	};
	
	const handleEmployeesClick = () => {
		setShowEmployees(companyEmployees);
	};
	
	const handleEmployeesModalClose = () => {
		setShowEmployees(null);
	};
	
	const handleCoursesClick = () => {
		setShowCourses(courseStats);
	};
	
	const handleCoursesModalClose = () => {
		setShowCourses(null);
	};
	
	const handleCreateCourseClick = () => {
		setShowCreateCourse(true);
	};
	
	const handleCreateCourseModalClose = () => {
		setShowCreateCourse(false);
	};
	
	const handleIndividualEmployeeModalClick = (employee) => {
		setShowIndividualEmployeeModal(employee);
	};

	const handleIndividualEmployeeModalClose = () => {
		setShowIndividualEmployeeModal(null);
	};
	
	const handleIndividualGroupModalClick = (group) => {
		setShowIndividualGroupModal(group);
	};

	const handleIndividualGroupModalClose = () => {
		setShowIndividualGroupModal(null);
	};
	
	const handleIndividualCourseModalClick = (course) => {
		setShowIndividualCourseModal(course);
	};

	const handleIndividualCourseModalClose = () => {
		setShowIndividualCourseModal(null);
	};
	
	const handleEmployeeClickFromTable = (employee) => {
		// setShowEmployees(null);
		setShowIndividualEmployeeModal(employee);
	};
	
	const handleGroupEmployeeSelected = (groupEmployee) => {
		for (let i in companyEmployees) {
			const employee = companyEmployees[i];
			if (groupEmployee.id === employee.id) {
				handleIndividualEmployeeModalClick(employee);
				return;
			}
		}
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar/>
			<AccountGuard requiredService="usecure"/>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Header pageTitle="Cyber Training"/>
				<Box sx={contentBoxStyle}>
					<Stack sx={{ width: "80%", margin: "auto" }} justifyContent="center">
						<Stack direction="row" sx={{ width: "100%", borderBottom: "2px solid", ...greyBorderStyle }}>
							<Box sx={{ width: "50%", borderRight: "solid 2px", ...greyBorderStyle }}>
								<Stack direction="column" sx={{ }}>
									<Typography
										variant="h5"
										sx={{ width: "100%", textAlign: "center", fontWeight: "bold", marginTop: "1em" }}
									>
										Organisation Risk Score
									</Typography>
									<Box sx={{ width: "100%", margin: "auto" }}>
										<Speedo
											value={companyEmployeeService.getCurrentRiskScore()}
											max={1000}
											scale={0.65}
											twoTone={true}
											sx={{ width: "100%" }}
										/>
									</Box>
								</Stack>
							</Box>
							<Box sx={{ width: "50%", ...greyBorderStyle }}>
								<Stack direction="column" sx={{ }}>
									<Typography
										variant="h5"
										sx={{ width: "100%", textAlign: "center", fontWeight: "bold", marginTop: "1em" }}
									>
										Risk Over Time
									</Typography>
									<RiskOverTimeGraph/>
								</Stack>
							</Box>
						</Stack>
						<Stack direction="row" sx={{ width: "100%", borderBottom: "2px solid", ...greyBorderStyle }}>
							<Box sx={{ width: "33%", margin: "1em 0" }}>
								<Stack direction="column" sx={{
									width: "90%",
									border: "solid 2px #ff03ed",
									margin: "1em auto",
									padding: "0.5em 0",
									borderRadius: "1.5em",
									height: "10em"
								}}>
									<Typography variant="h5" sx={{
										width: "100%",
										textAlign: "center",
										fontWeight: "bold",
										margin: "0.5em 0"
									}}>
										Cyber Training
									</Typography>
									<Stack
										direction="row"
										spacing="0.25em"
										sx={{ width: "100%", "&:hover": { cursor: "pointer" } }}
										onClick={() => {handleEmployeesClick();}}
									>
										<Typography sx={{ width: "50%", textAlign: "right" }}>Users</Typography>
										<Typography sx={{ width: "50%", textAlign: "left" }}>
											<ArrowBackIosNewIcon
												sx={{ transform: "rotate(270deg)", color: "text.border" }}
											/>
										</Typography>
									</Stack>
									<Stack
										direction="row"
										spacing="0.25em"
										sx={{ width: "100%", "&:hover": { cursor: "pointer" } }}
										onClick={() => {handleGroupClick(groups);}}
									>
										<Typography sx={{ width: "50%", textAlign: "right" }}>Groups</Typography>
										<Typography sx={{ width: "50%", textAlign: "left" }}>
											<ArrowBackIosNewIcon
												sx={{ transform: "rotate(270deg)", color: "text.border" }}
											/>
										</Typography>
									</Stack>
								</Stack>
							</Box>
							<Box sx={{ width: "33%", margin: "1em 0" }}>
								<Stack direction="column" sx={{
									width: "90%",
									border: "solid 2px #ff03ed",
									margin: "1em auto",
									padding: "0.5em 0",
									borderRadius: "1.5em",
									height: "10em"
								}}>
									<Typography variant="h5" sx={{
										width: "100%",
										textAlign: "center",
										fontWeight: "bold",
										margin: "0.5em 0"
									}}>
										Simulated Phishing
									</Typography>
									<Stack direction="row" spacing="0.25em" sx={{ width: "100%" }}>
										<Typography sx={{ width: "60%", textAlign: "right" }}>Opened</Typography>
										<Typography sx={{ width: "40%", textAlign: "left" }}>
											{"--"}
										</Typography>
									</Stack>
									<Stack direction="row" spacing="0.25em" sx={{ width: "100%" }}>
										<Typography sx={{ width: "60%", textAlign: "right" }}>Visited</Typography>
										<Typography sx={{ width: "40%", textAlign: "left", fontWeight: "bold", color: amber }}>
											{"--"}
										</Typography>
									</Stack>
									<Stack direction="row" spacing="0.25em" sx={{ width: "100%" }}>
										<Typography sx={{ width: "60%", textAlign: "right" }}>Compromised</Typography>
										<Typography sx={{ width: "40%", textAlign: "left", fontWeight: "bold", color: red }}>
											{"--"}
										</Typography>
									</Stack>
								</Stack>
							</Box>
							<Box sx={{ width: "33%", margin: "1em 0" }}>
								<Stack direction="column" sx={{
									width: "90%",
									border: "solid 2px #ff03ed",
									margin: "1em auto",
									padding: "0.5em 0",
									borderRadius: "1.5em",
									height: "10em"
								}}>
									<Typography variant="h5" sx={{
										width: "100%",
										textAlign: "center",
										fontWeight: "bold",
										margin: "0.5em 0"
									}}>
										Policy & Process
									</Typography>
									<Stack direction="row" spacing="0.25em" sx={{ width: "100%" }}>
										<Typography sx={{ width: "60%", textAlign: "right" }}>Total Policies</Typography>
										<Typography sx={{ width: "40%", textAlign: "left" }}>
											{policyService.policyStats.totalLive}
										</Typography>
									</Stack>
									<Stack direction="row" spacing="0.25em" sx={{ width: "100%" }}>
										<Typography sx={{ width: "60%", textAlign: "right" }}>Sent</Typography>
										<Typography sx={{ width: "40%", textAlign: "left" }}>
											{policyService.policyStats.totalRecipients}
										</Typography>
									</Stack>
									<Stack direction="row" spacing="0.25em" sx={{ width: "100%" }}>
										<Typography sx={{ width: "60%", textAlign: "right" }}>Signed</Typography>
										<Typography sx={{ width: "40%", textAlign: "left", fontWeight: "bold", color: "text.border" }}>
											{policyService.policyStats.policiesSigned}
										</Typography>
									</Stack>
								</Stack>
							</Box>
						</Stack>
						<Stack direction="row" sx={{ width: "100%" }}>
							<Box sx={{ width: "50%", padding: "3em 0", borderRight: "solid 2px", ...greyBorderStyle }}>
								<Box
									justifyContent="center"
									sx={{
										width: "80%",
										height: "5em",
										border: 2,
										margin: "0.25em auto",
										borderRadius: "2.5em",
										borderColor: "#ff03ed",
										textAlign: "center",
										padding: "0.5em",
										"&:hover": { cursor: "pointer" }
									}}
									onClick={handleHubClick}
								>
									<Typography sx={{ marginTop: "1em", fontSize: "1.1em", fontWeight: "bold" }}>
										Access People & Process Hub
									</Typography>
								</Box>
							</Box>
							<Box sx={{ width: "50%", padding: "3em 0" }}>
								<Box
									justifyContent="center"
									sx={{
										width: "80%",
										height: "5em",
										border: 2,
										margin: "0.25em auto",
										borderRadius: "2.5em",
										borderColor: "#ff03ed",
										textAlign: "center",
										padding: "0.5em",
										"&:hover": { cursor: "pointer" }
									}}
									onClick={handleMagicClick}
								>
									<Typography sx={{ marginTop: "1em", fontSize: "1.1em", fontWeight: "bold" }}>
										Generate Individual User Link
									</Typography>
								</Box>
							</Box>
						</Stack>
					</Stack>
					<GroupsModal
						groups={showGroup}
						onGroupSelected={handleIndividualGroupModalClick}
						onClose={handleGroupModalClose}
					/>
					<CompanyEmployeesModal
						companyEmployees={showEmployees}
						onEmployeeClick={handleEmployeeClickFromTable}
						onClose={handleEmployeesModalClose}
					/>
					<CoursesModal
						courseStats={showCourses}
						onCourseClick={handleIndividualCourseModalClick}
						onClose={handleCoursesModalClose}
					/>
					<CyberTrainingCreateCourseModal
						open={showCreateCourse}
						courseStats={courseStats}
						onCourseClick={handleIndividualCourseModalClick}
						onClose={handleCreateCourseModalClose}
					/>
					<IndividualEmployeeModal
						employee={showIndividualEmployeeModal}
						onClose={handleIndividualEmployeeModalClose}
					/>
					<IndividualGroupModal
						group={showIndividualGroupModal}
						onEmployeeSelected={handleGroupEmployeeSelected}
						onClose={handleIndividualGroupModalClose}
					/>
					<IndividualCourseModal
						course={showIndividualCourseModal}
						companyEmployees={companyEmployees}
						onEmployeeSelected={handleIndividualEmployeeModalClick}
						onClose={handleIndividualCourseModalClose}
					/>
				</Box>
			</Box>
		</Box>
	);
}

export default CyberTraining;
